import { FormControl, Grid, RadioGroup } from '@mui/material';
import { memo, useCallback } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { SectionVM } from 'civil-status/view-models/step-form';
import PmiTextField from 'shell/components/shared/text-field';
import { DatePicker } from '@mui/lab';
import Italian from '../../shared/italian';
import Foreign from '../../shared/foreign';
import { ItalianForm } from 'shell/view-models/italian-form';
import { ForeignForm } from 'civil-status/view-models/accordion-generality-form';
import { FormControlLabel } from '@mui/material';
import { Radio } from '@mui/material';

interface MarriageDataProps {
  disabled?: boolean;
  values?: SectionVM;
  errors?: FormikErrors<SectionVM>;
  touched?: FormikTouched<SectionVM>;
  onChange: (key: keyof SectionVM, value: SectionVM[keyof SectionVM]) => void;
  onChanges: (values: SectionVM) => void;
  configuration?: string;
  nothingRequired?: boolean;
}

const MarriageDataComponent = ({
  disabled = false,
  values,
  errors,
  touched,
  onChange,
  onChanges,
}: MarriageDataProps): React.ReactElement => {
  const onChangeItalian = useCallback(
    (key, value) => {
      onChange('italian', {
        ...(values || {}).italian,
        [key]: value,
      });
    },
    [values, onChange]
  );

  const onChangesItalian = useCallback(
    (valuesNew) => {
      onChange('italian', {
        ...(values || {}).italian,
        ...valuesNew,
      });
    },
    [values, onChange]
  );

  const onFieldForeignChange = useCallback(
    (key, value) => {
      onChange('foreign', {
        ...(values || {}).foreign,
        [key]: value,
      });
    },
    [values, onChange]
  );

  const onFieldsForeignChange = useCallback(
    (valuesNew) => {
      onChange('foreign', {
        ...(valuesNew || {}),
      });
    },
    [values, onChange]
  );
  return (
    <Grid container spacing={2} item xs={12}>
      <Grid item xs={12} md={4}>
        <DatePicker
          label="Data matrimonio *"
          aria-label="Data matrimonio"
          value={values?.dateEvent || null}
          onChange={(date) => {
            onChange('dateEvent', date);
          }}
          disabled={disabled}
          renderInput={(params) => (
            <PmiTextField
              {...params}
              id="dateEvent"
              fullWidth
              helperText={errors?.dateEvent}
              error={touched?.dateEvent && Boolean(errors?.dateEvent)}
            />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControl component="fieldset">
          <RadioGroup
            row
            aria-label="Stato"
            id="isForeign"
            value={values?.isForeign || 'false'}
            onChange={() => {
              onChanges({
                ...(values || {}),
                isForeign: !values?.isForeign,
                italian: {
                  location: '',
                  province: '',
                  municipality: null,
                },
                foreign: {
                  state: null,
                  province: '',
                  municipality: null,
                },
              });
            }}
          >
            <FormControlLabel
              value="false"
              control={<Radio />}
              label="Italia"
              disabled={disabled}
            />
            <FormControlLabel value="true" control={<Radio />} label="Estero" disabled={disabled} />
          </RadioGroup>
        </FormControl>
      </Grid>
      {!values?.isForeign ? (
        <Italian
          disabledComponent={disabled}
          values={values?.italian}
          onChange={onChangeItalian}
          onChanges={onChangesItalian}
          errors={errors?.italian as FormikErrors<ItalianForm>}
          touched={touched?.italian as unknown as FormikTouched<ItalianForm>}
          labelMunicipality="Comune ente"
          labelProvince="Provincia ente"
          required
          fromDate={values?.documentDateFormation || null}
        />
      ) : (
        <Foreign
          disabledComponent={disabled}
          values={values?.foreign}
          onChange={onFieldForeignChange}
          onChanges={onFieldsForeignChange}
          labelState="Stato ente"
          errors={errors?.foreign as FormikErrors<ForeignForm>}
          touched={touched?.foreign as unknown as FormikTouched<ForeignForm>}
          required
          isWithLocationForeign
        />
      )}
    </Grid>
  );
};

MarriageDataComponent.displayName = 'Form Marriage Data component';

const MarriageData = memo(MarriageDataComponent);

export default MarriageData;
